<template>
    <div class="columns is-multiline">
        <div class="column">
            <div class="box" id="method">
                <h4 class="title is-6">VARIABLE:METHOD - scaled from transparent to opaque:</h4>
                <ol class="small-list">
                    <li>Subterfuge/use of misleading methods</li>
                    <li>Undercover/covert work (non-invasive observation, casing, etc.)</li>
                    <li>Private document analysis; interviews/leaks from anonymous figures, in private</li>
                    <li>Proprietary document analysis; interviews/leaks from public figures, in public</li>
                    <li>Public document analysis; open source intelligence</li>
                </ol>
            </div>
        </div>
        <div class="column">
            <div class="box" id="pragmatics">
                <h4 class="title is-6">VARIABLE:PRAGMATICS (social importance); scaled from public to private:</h4>
                <ol class="small-list">
                    <li>Affect change at private (personal) level, in private</li>
                    <li>Affect change at private (personal) level, in public</li>
                    <li>Affect change at local governmental/public/private institutional level</li>
                    <li>Affect change at national governmental/public/private institutional level</li>
                    <li>Affect change at global governmental/public/private institutional level</li>
                </ol>
            </div>
        </div>
        <div class="column">
            <div class="box" id="aesthetics">
                <h4 class="title is-6">VARIABLE:AESTHETICS - scaled from impartial to sensational: </h4>
                <ol class="small-list">
                    <li>Very easy to read. Easily understood by an average 11-year-old student</li>
                    <li>Easy to read. Conversational English for consumers</li>
                    <li>Fairly easy to read</li>
                    <li>Plain English. Easily understood by 13- to 15-year-old students</li>
                    <li>Fairly difficult to read</li>
                    <li>College	level</li>
                    <li>College graduate level</li>
                </ol>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Variables"
    }
</script>

<style scoped>


 .box {
   background-color: #f3f3f3;
 }

  .small-list{
    padding: 5px 10px;
  }

</style>
